import React from 'react';
import './Layout.css';

function Footer() {
  return (
    <footer className="app-footer">
      <p>&copy; {new Date().getFullYear()} Ponus Admin Dashboard. All rights reserved.</p>
    </footer>
  );
}

export default Footer;